import NoImageSrc from "@/assets/images/no_image.svg";
import CldImage from "@/components/ui/cldImg/CldImage";
import { getCloudinaryURL } from "@/utils/cloudinary";
import root from "react-shadow";
import { CustomTabProps } from "../../types";

const CustomTabs = (props: CustomTabProps & { id: string }) => {
    const { data, id, key } = props;
    return (
        <div
            id={id}
            className="flex h-full flex-col items-center justify-center max-md:px-5 max-md:py-5 lg:flex-row"
        >
            <div className="flex flex-1 flex-col items-center gap-6 py-5">
                <div className="lg:w-[80%]">
                    <root.span>
                        <style>
                            {`
            a {
                color:#666666;
              }
          `}
                        </style>

                        {data?.description ? (
                            <div
                                className="my-12 flex flex-col items-center lg:pe-10"
                                dangerouslySetInnerHTML={{ __html: data.description }}
                            />
                        ) : (
                            ""
                        )}
                    </root.span>
                </div>
            </div>
            <div className="flex h-[9.75rem] w-full flex-1 items-center justify-center md:h-[30.625rem] lg:w-[62.75rem]">
                <CldImage
                    src={data.media ? getCloudinaryURL(data.media) : NoImageSrc.src}
                    alt={"image"}
                    width={708}
                    height={608}
                    className="w-full invert-[2%]"
                />
            </div>
        </div>
    );
};

export default CustomTabs;
